<template>
  <div>
    <IQOS class="w-fitcontent mt-0" boxClass="container-box p-0  h-63">
      <template v-slot:header>
        <div class="history-block">
          <h3 class="title-box mr-2">Історія замовлень за</h3>

          <v-date-picker v-model="range" class="history-date-picker" mode="range" locale="uk" is-dark color="green" />

          <!-- <datepicker :value="range.start" style="color:#1d1d1b;"></datepicker>
          <h3 class="title-box mx-2">&mdash;</h3>
          <datepicker :value="range.end" style="color:#1d1d1b;"></datepicker>-->
          <!-- <input type="date" class="set-day" v-model="range.start" />
          <input type="date" class="set-day" v-model="range.end" />-->
        </div>
      </template>

      <div class="order-history-container">
        <table class="table c-white">
          <thead>
            <tr>
              <th scope="col">№</th>
              <th scope="col">ID чеку</th>
              <th scope="col">
                Дата та час
                <br />створення замовлення
              </th>
              <th scope="col">Клієнт</th>
              <th scope="col">
                Час
                <br />оплати
              </th>
              <th scope="col">Сума</th>
              <th scope="col">
                Час
                <br />прийняття
              </th>
              <th scope="col">
                Плановий
                <br />час відправки
              </th>
              <th scope="col">
                Фактичний
                <br />час відправки
              </th>
              <th scope="col">
                Вартість
                <br />доставки
              </th>
              <th scope="col">№</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="item._id">
              <td>{{ index+1 }}</td>
              <th scope="row">{{ item.local_id }}</th>
              <td>{{ item.created_at | formatDatetime}}</td>
              <td>
                {{ item.client.name }}
                <br />
                {{item.client.phone}}
                <br />
                {{item.client.address}}
              </td>
              <td>{{ item.confirmed_at | formatTime }}</td>
              <td>{{ item.total }} UAH</td>
              <td>{{ item.accepted_at | formatTime }}</td>
              <td>{{ item.serve_date | formatTime}}</td>
              <td>{{ item.closed_at | formatTime }}</td>
              <td>{{ item.delivery_profit || 0 }} UAH</td>
              <td>{{ index+1 }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template v-slot:ordersTable>
        <div class="orders-info">
          <div class="row">
            <div class="col-6 c-green">
              <span class="float-left">Дохід закладу</span>
              <span class="float-right">{{ totalProfit }} грн.</span>
            </div>
            <div class="col-6 pl-0 position-relative">
              <span class="float-left c-white">Доставка:</span>
              <span class="float-right c-white">{{ totalDeliveryCost }} грн.</span>
              <p
                class="mt-7 mb-0 c-grey"
                v-if="deliveryPartner"
              >Тариф за доставку нараховуються згідно Ваших домовленостей з партнером DELIVERY</p>
              <p
                class="mt-7 mb-0 c-grey"
                v-if="!deliveryPartner"
              >Тариф за доставку нараховується згідно Ваших налаштувань DELIVERY. Поточна вартість доставки: {{cafe.delivery.cost}} UAH</p>
            </div>
          </div>
        </div>
      </template>
    </IQOS>
  </div>
</template>


<style>
.h-63 {
  height: 63vh !important;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

 <style scoped>
table {
  white-space: nowrap;
  width: auto;
}

.ml-2 {
  margin-left: 2vh !important;
}

td {
  font-size: 2vh;
  overflow-y: hidden;
}

input.set-day {
  width: auto;
  background: #ededed;
  padding: 0 0.5vh;
  text-align: center;
  border-radius: 0.1vh;
  color: #1d1d1b;
  text-align: center;
  margin-left: 2vh;
  line-height: 0.8;
  font-size: 2.8vh;
  border: none;
}

h3.title-box {
  height: fit-content;
  line-height: 0.8;
  font-size: 2.8vh;
  margin-bottom: 0;
}

.history-block {
  align-items: center;
  display: flex;
}

.mt-7 {
  margin-top: 7vh;
  font-size: 2.2vh;
}

.col-6.pl-0 {
  padding-right: 1.5vh;
}

span {
  font-size: 3vh;
  padding-top: 2vh;
}

.table th {
  padding: 1vh 3vh;
  border-top: 0;
}

.table td:first-child {
  border-bottom: none;
}

.table thead th,
.table tr {
  font-size: 2.2vh;
}

.w-fitcontent {
  padding-right: 3.5vh;
  width: fit-content !important;
}

.order-history-container {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

tbody {
  overflow: auto;
  max-height: 50vh;
  /* position: absolute; */
}

.order-history-container thead {
  /* border-bottom: 1px solid #ededed; */
}

.order-history-container thead th {
  position: sticky;
  top: 0;
  background: #1d1d1b;
}

.history-date-picker,
.history-date-picker input {
  border-radius: 0.7vh;
  position: relative;
  top: -0.7vh;
  width: 27.3vh;
  margin: 0;
  font-size: 1.2vh !important;
}


</style>

<style>
.vc-py-2 {
  padding-top: 0;
  padding-bottom: 0;
}

.vc-3-px {
  padding-left: 1.2vh;
  padding-top: 1.2vh
}

.vc-text-base {
  font-size: 2vh;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import PreorderAPI from "@/api/preorder";
import moment from "moment";

import TaxiService from "@/services/taxi";

export default {
  components: {
    IQOS,
    IQOSActions
  },
  data() {
    return {
      list: [],
      range: {
        start: moment().startOf("week").toDate(),
        end: moment().endOf("week").toDate()
      }
    };
  },
  watch: {
    "range.start"() {
      this.fetchData();
    },
    "range.end"() {
      this.fetchData();
    }
  },
  methods: {
    onNewDelivery(obj) {
      const check_date = moment(obj.created_at);

      const start = moment(this.range.start).startOf("day");
      const end = moment(this.range.end).endOf("day");

      if (check_date.isBetween(start, end)) this.list.unshift(obj);
    },
    onConnect() {
      TaxiService.listenCafe(this.$store.state.cafe._id);
    },
    fetchData() {
      const start = moment(this.range.start).startOf('day').valueOf();
      const end = moment(this.range.end).endOf('day').valueOf();

      PreorderAPI.queryArchive(this.$store.state.cafe._id, start, end)
        .then(data => {
          this.list = data.list.filter(p => p.is_delivery);
        })
        .catch(error => {
          console.error(error);
        });

      TaxiService.connect({
        onNewDelivery: this.onNewDelivery.bind(this),
        onConnect: this.onConnect.bind(this)
      });
    }
  },
  computed: {
    totalIncome() {
      return this.list.reduce((acc, item) => (acc += item.total), 0);
    },
    totalProfit() {
      return this.totalIncome - this.totalDeliveryCost;
    },
    totalDeliveryCost() {
      return this.list.reduce((acc, item) => (acc += item.delivery_profit), 0);
    },
    deliveryPartner() {
      return this.$store.getters.deliveryPartner;
    },
    cafe() {
      return this.$store.state.cafe;
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
